import { api } from '@/apis';

import { useCoreQuery } from '../core';
import { keys } from '../keys';

/**
 * 리뷰 상세 조회
 * @param review_id
 */
export const useReviewQuery = (review_id: string) =>
  useCoreQuery(keys.review.get(review_id), () =>
    api.review.getReview(review_id).then((res) => res),
  );

/**
 * 리뷰 작성 가능한 주문 상품 조회
 * @param order_group_number
 */
export const useReviewableOrderlinesQuery = (order_group_number: string, enabled?: boolean) =>
  useCoreQuery(
    keys.review.reviewableOrderlines(order_group_number),
    () => api.review.getReviewableOrderlines(order_group_number).then((res) => res),
    {
      enabled,
    },
  );
